export const UPLOAD_STARTED = 'app/UPLOAD_STARTED';

export const uploadStarted = payload => ({
  type: UPLOAD_STARTED,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/upload-started.js